import axios from 'axios';
import { forceLogout } from './logout';

const shouldLogout = (status, message) => {
  if (status === 401) return true;
  if (typeof message === 'string') {
    const m = message.toLowerCase();
    if (m.includes('invalid token')) return true;
  }
  return false;
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message || error?.response?.data?.error || error?.message;
    if (shouldLogout(status, message)) {
      forceLogout('Invalid token. Please login again.');
    }
    return Promise.reject(error);
  }
);